<div class="card-container">
  @if (showLoader) {
    <div class="col loader-div">
      <div class="d-flex justify-content-center align-items-center h-100">
        <div class="spinner-grow bg-danger" style="width: 3rem; height: 3rem" role="status">
          <span class="visually-hidden"></span>
        </div>
        <div style="position: absolute; padding-top: 100px">
          <h5 class="text-dark text-uppercase font-weight-bold">{{ 'processing' | translate }}</h5>
        </div>
      </div>
    </div>
  }

  <div id="pdfContent">
    <div class="card" id="page1">
      <div class="col p-0">
        <div
          id="excludeSection"
          class="w-100 text-end p-4 row timeline-buttons"
          style="
            cursor: pointer;
            background-color: #eceef1;
            justify-content: space-between;
            align-items: baseline;
            position: relative;
            left: 12px;
          ">
          <div class="mb-2">
            <span class="f-18 _800">{{ 'Print Timeline' | translate }}</span>
          </div>
          <div class="d-flex row ps-2">
            <div class="dropdown-container responsive-card">
              <select class="custom-dropdown" (change)="handleFileExtension($event)">
                <option value="PDF">{{ 'Export as PDF' | translate }}</option>
                <option value="PPT">{{ 'Export as PPT' | translate }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="col">
          <div class="row">
            <div class="col-md-6 col-sm-12 right-border mt-3 ps-md-4">
              <div class="company-logo-img-div d-flex justify-content-center align-items-center" style="top: 31px">
                @if (timelineData?.logo) {
                  <img
                    class="company-logo"
                    [ngSrc]="timelineData?.logo"
                    (error)="timelineData.logo = null"
                    alt="timelineData-logo"
                    fill="" />
                } @else {
                  <span
                    class="d-flex justify-content-center align-items-center c-full-white profile-text _800 text-uppercase company-logo"
                    [style.background-color]="timelineService.getColorFromName(timelineData?.name || headerTitle)">
                    {{ timelineData?.name ? (timelineData.name | slice: 0 : 2) : (headerTitle | slice: 0 : 2) }}
                  </span>
                }
              </div>
              <div>
                <div class="header-title-div">
                  <span class="company-title">{{ headerTitle }}</span>
                </div>
                <div class="title-div">
                  <span class="company-header-title">{{ headerSubtitle }}</span>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-sm-12 description-container">
              <span class="description-heading">{{ 'Description' | translate }}</span>
              <div class="description">{{ timelineData.description || 'NA' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="col mt-3">
        @if (isCriteriaForm2Enabled) {
          <div class="col">
            <mtm-summary-block
              [isDownloadComponentActive]="true"
              [timelineData]="timelineData"
              [workspaceName]="headerTitle"></mtm-summary-block>
          </div>
        }

        @if (isCriteriaForm1Enabled) {
          <div class="col">
            <mtm-summary-block-criteria-1
              [isDownloadComponentActive]="true"
              [timelineData]="timelineData"></mtm-summary-block-criteria-1>
          </div>
        }

        @if (isSimplifiedCriteriaEnabled) {
          <div class="col">
            <mtm-summary-block-simplified [timelineData]="timelineData"></mtm-summary-block-simplified>
          </div>
        }

        @if (isFullTimeline) {
          <div class="mt-4">
            <div class="ms-3" style="margin-right: -15px">
              <mtm-timeline-blocks
                [timeLineData]="timelineData"
                [multiViewsSupport]="true"
                [canEdit]="false"
                [IsDownload]="true"></mtm-timeline-blocks>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="card col pb-5 mb-2" id="page2">
    @if (visualizations.length) {
      <div class="col mt-2">
        <div class="mt-3">
          @for (v of visualizations; track $index; let i = $index) {
            <span class="f-22 _500 c-mtm-full-black">
              {{ v.name }}
              <i
                class="ms-3 fa fa-clone text-dark"
                style="font-size: 15px; cursor: pointer"
                title="Copy visualization"
                (click)="generateImage(`visualization${i + 1}`)"></i>
            </span>

            @if (!v.isBothSelected) {
              <div class="d-flex flex-wrap bg-white" [id]="`visualization${i + 1}`">
                @for (item of v.milestone; track $index) {
                  <div class="col-sm-1 my-2 p-0" [style.max-width]="'73px'">
                    <div class="visualization-card-mad-div" [style.background-color]="item.blockColor">
                      <div
                        ><span class="milestone-card-div-text">{{ item.mad }}</span></div
                      >
                      <div class="milestone-mad-date">
                        <span class="milestone-card-div-text">{{ item.driveDate | date: 'dd.MM.YYYY' }}</span>
                      </div>
                    </div>
                    <div class="visualization-name-div" [style.height]="'60px'">
                      <div class="p-1">
                        <span class="milestone-name-text _800">{{ item.blockName }}</span>
                        <span class="milestone-name-text">{{ item.name }}</span>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }

            <div [id]="`visualization${i + 1}`">
              @if (v.isBothSelected) {
                <div class="row mt-1">
                  <span class="ps-3 f-14 _600">Colored ordered sorted</span>
                </div>
                <div class="d-flex flex-wrap bg-white">
                  @for (item of v.colorSortedMilestones; track $index) {
                    <div class="col-sm-1 my-2 p-0" [style.max-width]="'73px'">
                      <div class="visualization-card-mad-div" [style.background-color]="item.blockColor">
                        <div
                          ><span class="milestone-card-div-text">{{ item.mad }}</span></div
                        >
                        <div class="milestone-mad-date">
                          <span class="milestone-card-div-text">{{ item.driveDate | date: 'dd.MM.YYYY' }}</span>
                        </div>
                      </div>
                      <div class="visualization-name-div" [style.height]="'60px'">
                        <div class="p-1">
                          <span class="milestone-name-text _800">{{ item.blockName }}</span>
                          <span class="milestone-name-text">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <div class="row mt-1">
                  <span class="ps-3 f-14 _600">Chronological order sorted</span>
                </div>
                <div class="d-flex flex-wrap bg-white">
                  @for (item of v.chronologicalSortedMilestones; track $index) {
                    <div class="col-sm-1 my-2 p-0" [style.max-width]="'73px'">
                      <div class="visualization-card-mad-div" [style.background-color]="item.blockColor">
                        <div
                          ><span class="milestone-card-div-text">{{ item.mad }}</span></div
                        >
                        <div class="milestone-mad-date">
                          <span class="milestone-card-div-text">{{ item.driveDate | date: 'dd.MM.YYYY' }}</span>
                        </div>
                      </div>
                      <div class="visualization-name-div" [style.height]="'60px'">
                        <div class="p-1">
                          <span class="milestone-name-text _800">{{ item.blockName }}</span>
                          <span class="milestone-name-text">{{ item.name }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>

  <div class="download-btn-div mt-5">
    <button class="file-download-btn" (click)="downloadImages()">
      <i class="fa fa-file fa-lg me-3 file-download-icon"></i>
      <span class="file-download-btn-title">
        {{ extension === 'PDF' ? ('downloadAsPdf' | translate) : ('downloadAsPpt' | translate) }}
      </span>
    </button>
  </div>
</div>
